/* eslint-disable */

import React, { useMemo, useEffect } from "react";
import { renderReact } from "../src/lib/ssrHydrator";
import ArticleSearchContainer from "../src/ArticleSearchForm/containers/ArticleSearchContainer";
import InsertContentRenderer from "../src/ArticleSearchForm/components/common/InsertContentRenderer";
import CompanyPCRecommendArticlesBox from "../src/components/RecommendArticlesBox/companies/pc/index";
import CompanyPCArticleBox from "../src/ArticleSearchForm/components/companies/pc/PCArticleBox";
import Article from "../src/entities/article";

function NotFoundMessage() {
  return (
    <h2 className="resultHeaderDesc notFoundMessage">
      条件に当てはまる募集は見つかりませんでした。
    </h2>
  );
}

const createRecAnywhereParam = (recommendOnline) => ({
  heading: "似た条件のオンラインボランティア",
  articles: recommendOnline,
});

function AssignOrPush(props) {
  return <>{props.target ? [props.target, props.content] : props.content}</>;
}

const insertContentsCountCutOff = 16;

const createInsertContents = ({
  results = [],
  recommendOnline = [],
  companyName,
  page,
}) => {
  const count = results.length;
  const recAnywhere = createRecAnywhereParam(recommendOnline);
  const setting = {};
  if (
    count > insertContentsCountCutOff &&
    recommendOnline.length > 0 &&
    page === 1
  ) {
    setting[count - insertContentsCountCutOff] = (
      <AssignOrPush
        target={setting[count - insertContentsCountCutOff]}
        content={
          <CompanyPCRecommendArticlesBox
            {...recAnywhere}
            idx={count - insertContentsCountCutOff}
            company_name={companyName}
          />
        }
      />
    );
  }
  return setting;
};

export function CompanyPCArticleListWrapper({
  company_name,
  company_name_ja,
  is_bookmark,
}) {
  const articleSearch = ArticleSearchContainer.useContainer();
  const args = {
    results: articleSearch.results,
    recommendOnline: articleSearch.recommendOnline,
    companyName: company_name,
    page: articleSearch.page,
  };
  const insertContents = useMemo(
    () => createInsertContents(args),
    [articleSearch.results, articleSearch.recommendOnline]
  );
  return (
    <CompanyPCArticleList
      results={articleSearch.results}
      company_name={company_name}
      company_name_ja={company_name_ja}
      insert_contents={insertContents}
      is_bookmark={is_bookmark}
    />
  );
}

function CompanyPCArticleList({
  results,
  company_name,
  company_name_ja,
  is_bookmark,
  insert_contents,
}) {
  useEffect(() => {
    const event = new CustomEvent("react_rendering");
    window.dispatchEvent(event);
  }, []);

  function ArticleListItem({ i, article }) {
    return (
      <React.Fragment key={article.id}>
        <InsertContentRenderer insertContent={insert_contents[i]} />
        <CompanyPCArticleBox
          article={new Article({ ...article })}
          company_name={company_name}
          company_name_ja={company_name_ja}
        />
      </React.Fragment>
    );
  }

  function ArticleList({ articles }) {
    let pickup_begin_flag = false;
    let article_begin_flag = false;
    return (
      <>
        {articles.map((article, i) => {
          if (article.pickup && !pickup_begin_flag && !is_bookmark) {
            pickup_begin_flag = true;
            return (
              <>
                <h2 key={article.id}>ピックアップ</h2>
                <hr />
                <ArticleListItem i={i} article={article} />
              </>
            );
          }
          if (!article.pickup && !article_begin_flag && !is_bookmark) {
            article_begin_flag = true;
            return (
              <>
                <h2 key={article.id}>募集一覧</h2>
                <hr />
                <ArticleListItem i={i} article={article} />
              </>
            );
          }
          return <ArticleListItem i={i} article={article} />;
        })}
      </>
    );
  }

  return results.length === 0 ? (
    <NotFoundMessage />
  ) : (
    <div className="m_mainArticleList hasBorder">
      <ArticleList articles={results} />
    </div>
  );
}

CompanyPCArticleList.defaultProps = {
  is_bookmark: false,
  insert_contents: {},
};

export default renderReact("CompanyPCArticleList", CompanyPCArticleList);
